'use client';

import type { ProductDisplayData as Product } from '@eliadmin/core/src/api/products/types/product-types';

type CustomAvailabilityLabelProps = {
  product: Product;
};

export function CustomAvailabilityLabel({ product }: CustomAvailabilityLabelProps) {
  const availability = product.availability;
  const unavailability = product.unavailability;

  // Use the same decision logic as in ProductStock to choose which label to show
  const useAvailability = product.quantity > 0 || Boolean(availability?.sellable);
  const activeLabel = useAvailability ? availability : unavailability;

  if (!activeLabel) return null;

  const backgroundColor =
    !activeLabel.color || activeLabel.color === '' ? '#5f53e1ff' : activeLabel.color;

  return (
    <div
      className="flex h-5 items-center justify-center whitespace-nowrap rounded-full px-2 text-xs font-normal text-white"
      style={{ backgroundColor }}
    >
      {activeLabel.name}
    </div>
  );
}
